// Core
import React from "react";

// Core
import "./styles.scss";
import ImageModal from "Components/ImageModal";
import PDFIcom from "Assets/Images/pdfImg.png";

const ApprovalSparePartsLogo = ({ data }) => {
  return (
    <div className="approvalSparePartsLogoWrap mx-3 mt-3 mb-5">
      <div className="sparePartsLabel">
        <label>KG Product Offerings</label>
      </div>
      <div className="sparePartsLogoContWrap my-3 py-4 px-4">
        <label className="sparePartDetailSubLabel">
          Spare Parts Log Details
        </label>
        <div className="row mt-2">
          <div className="col-6">
            <div className="sparePartsSubLabel my-3">Module Name</div>
            <div className="sparePartsSubLabelCont">{data?.module_name || "-"}</div>
          </div>
          <div className="col-6">
            <div className="sparePartsSubLabel my-3">Product Name</div>
            <div className="sparePartsSubLabelCont">{data?.product_name || "-"}</div>
          </div>
          <div className="col-6 my-4">
            <div className="sparePartsSubLabel my-3">Recommendations</div>
            <div className="sparePartsSubLabelCont" style={{textAlign: "justify"}}>
              {data?.recommendations || "-"}
            </div>
          </div>
          <div className="col-6 my-4">
            <div className="sparePartsSubLabel my-3">Priority</div>
            <div className="sparePartsSubLabelCont">{data?.priority || "-"}</div>
          </div>
          {/* <div className="col-6">
            <div className="sparePartsSubLabel my-3">Operating Condition</div>
            <div className="sparePartsSubLabelCont">
              {data?.operating_condition}
          <div className="col-6">
            <div className="sparePartsSubLabel my-3">Issues Being Faced</div>
            <div className="sparePartsSubLabelCont">
              {data?.issues_being_faced}
          </div> */}
        </div>
        <div className="my-3">
          <label className="sparePartsSubLabel">Photos</label>
          <div>
            <div className="d-flex flex-wrap align-items-center my-2">
              {data?.photos?.length > 0 ? (
                <>
                  {data?.photos?.map((item, index) => {
  const isPDF = item.toLowerCase().endsWith(".pdf");
  return (
    <div key={index}>
      {isPDF ? (
        <div className="pdf-container">
        <div className="individual-pdf-container" style={{padding: "10px"}}>
          <a href={item} target="_blank" rel="noopener noreferrer">
            <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
            <p>Open PDF</p>
          </a>
        </div>
      </div>
      ) : (
        <ImageModal src={item} alt={`photo-${index}`} className="photos" />
      )}
    </div>
  );
})}

                </>
              ) : (
                <div>-</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalSparePartsLogo;
